import React from 'react';

import { Button } from 'apps/auth/components/common/Button/Button';
import { DocsList } from 'apps/auth/components/common/components/DocsList/DocsList';
import { DocsListItem } from 'apps/auth/components/common/components/DocsList/DocsListItem';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { USA } from 'apps/auth/constants/WellKnownCountries';

const ServerSideDisclaimer = ({ content, onButtonClick, userCountry, linkTo, detailsClick, onCloseClick, title, getParagraphHeader, overflowHidden }) => {
    return (
        <ModalComponent hasBottomPanel linkTo={linkTo} onCloseIconClick={onCloseClick} overflowHidden={overflowHidden}>
            <HeaderPanel title={title} />
            {content.text && <Row indent="adaptive-16-24">{<DangerouslyHtml color="secondary" dangerouslyHtml={content.text || ''} />}</Row>}
            {content.linkButton && (
                <Button
                    caption={content.linkButton.title}
                    href={content.linkButton.locationsUrl}
                    type="link"
                    target="_blank"
                    variant="row"
                    size="tight"
                    negativeMargin
                />
            )}
            <DocsList>
                {content.sections?.map((section, i) => {
                    const locationsUrl = section.linkButton?.locationsUrl;
                    return (
                        <DocsListItem title={getParagraphHeader ? getParagraphHeader(section, i) : section.header} key={section.number ?? i}>
                            <Row indent="adaptive-16-24">
                                <DangerouslyHtml color="secondary" dangerouslyHtml={userCountry === USA && section.textUsa ? section.textUsa : section.text} />
                            </Row>
                            {section.copyrightText && (
                                <Text size="secondary" color="secondary">
                                    {section.copyrightText}
                                </Text>
                            )}
                            {section.linkButton && (
                                <>
                                    {locationsUrl ? (
                                        <Button
                                            caption={section.linkButton.title}
                                            href={locationsUrl}
                                            type="link"
                                            target="_blank"
                                            variant="row"
                                            size="tight"
                                            negativeMargin
                                        />
                                    ) : (
                                        <Button
                                            caption={section.linkButton.title}
                                            onClick={(e) => {
                                                detailsClick?.(e, section.linkButton?.bottomSheetBanks, section.linkButton?.bottomSheet);
                                            }}
                                            type="button"
                                            variant="row"
                                            size="tight"
                                            negativeMargin
                                        />
                                    )}
                                </>
                            )}
                        </DocsListItem>
                    );
                })}
            </DocsList>
            {content.continueButton && (
                <FixedBottomPanel isRightAligned>
                    <Button
                        type="button"
                        raised={true}
                        onClick={() => {
                            onButtonClick();
                        }}
                        caption={content.continueButton}
                        dataTestId="disclaimer-continue-button"
                    />
                </FixedBottomPanel>
            )}
        </ModalComponent>
    );
};

export default ServerSideDisclaimer;
